import { Platform } from '@angular/cdk/platform';
import { Component, Input, OnInit, inject } from '@angular/core';
import { BreakpointService } from '@simOn/ui/breakpoint';
import { map } from 'rxjs';
import { FullScreenService } from './full-screen.service';

let uniqueIdCounter = 0;
@Component({
    selector: 'sim-fullscreen',
    templateUrl: './sim-fullscreen.component.html',
    styleUrls: ['./sim-fullscreen.component.scss'],
    host: { '[id]': 'id' },
    standalone: false
})
export class SimFullscreenComponent implements OnInit {
  private readonly breakpointService = inject(BreakpointService);
  private readonly platform = inject(Platform);
  public readonly fullScreenService = inject(FullScreenService);
  @Input() id = `sim-fullscreen-${uniqueIdCounter++}`;

  isFullScreen: boolean = false;
  readonly isAndroidOrDesktop$ = this.breakpointService.deviceType$.pipe(
    map((deviceType) => deviceType === 'desktop' || this.platform.ANDROID)
  );

  ngOnInit(): void {
    this.fullScreenService.isFullScreen.subscribe((data) => {
      this.isFullScreen = data;
    });
  }

  fullScreen(): void {
    this.fullScreenService.setIsFullScreen(!this.isFullScreen);
  }
}
